"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SPONSOR_SESSION_STORAGE_KEY = exports.GIFT_ICON = exports.GIFT_ANIMATION_REPEAT_TIMES = exports.GIFT_ANIMATION_DURATION_SECONDS = exports.FLOATING_BANNER_MESSAGE = exports.FLOATING_BANNER_GREETING = exports.FLOATING_BANNER_CLOSE_ICON = exports.FLOATING_BANNER = void 0;
const FLOATING_BANNER = exports.FLOATING_BANNER = 'floating-banner';
const FLOATING_BANNER_MESSAGE = exports.FLOATING_BANNER_MESSAGE = 'floating-banner-message';
const FLOATING_BANNER_GREETING = exports.FLOATING_BANNER_GREETING = 'floating-banner-greeting';
const FLOATING_BANNER_CLOSE_ICON = exports.FLOATING_BANNER_CLOSE_ICON = 'floating-banner-close-icon';
const GIFT_ICON = exports.GIFT_ICON = 'gift-icon';
const GIFT_ANIMATION_DURATION_SECONDS = exports.GIFT_ANIMATION_DURATION_SECONDS = 1;
const GIFT_ANIMATION_REPEAT_TIMES = exports.GIFT_ANIMATION_REPEAT_TIMES = 2;
const SPONSOR_SESSION_STORAGE_KEY = exports.SPONSOR_SESSION_STORAGE_KEY = 'sponsorBannerClosed';